import { gql } from "@apollo/client";

const MYQRCODE = gql`
  subscription Myqrcode {
    myqrcode
  }
`;

export { MYQRCODE }